import { gql } from '@apollo/client'

export const RASED_QA_UPDATE_RECORD = gql`
  mutation RasedQAUpdateRecord($recordInput: UpdateQARecordInputType!) {
    rasedQaUpdateRecord(recordInput: $recordInput) {
      record {
        id
        data
        geometry
      }
    }
  }
`
